<app-ip-analysis-drawer>
    <router-outlet></router-outlet>
</app-ip-analysis-drawer>